import { render, staticRenderFns } from "./drawerDetail.vue?vue&type=template&id=5624d3d1&scoped=true"
import script from "./drawerDetail.vue?vue&type=script&lang=js"
export * from "./drawerDetail.vue?vue&type=script&lang=js"
import style0 from "./drawerDetail.vue?vue&type=style&index=0&id=5624d3d1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5624d3d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5624d3d1')) {
      api.createRecord('5624d3d1', component.options)
    } else {
      api.reload('5624d3d1', component.options)
    }
    module.hot.accept("./drawerDetail.vue?vue&type=template&id=5624d3d1&scoped=true", function () {
      api.rerender('5624d3d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/merchantAccount/components/drawerDetail.vue"
export default component.exports